import { useAuth } from "@wojo/auth";
import { CurrencyCode } from "@wojo/services/generated/graphql";
import { useState, useEffect } from "react";
import {
    useAddDraftOrderPromoMutation,
    useStartQuoteMutation,
} from "../../../../generated/graphql";
import { useTripBuilder } from "./TripBuilderContext";
import Cookies from "js-cookie";
import { useDraftQuoteFragment } from "./use-draft-quote-fragment";

export const useStartQuote = (
    draftId: string | null,
    setDraftId: React.Dispatch<React.SetStateAction<string | null>>,
) => {
    const {
        departureId,
        gcDeparture,
        promoCode,
        campaignCode,
        setDepartureId,
    } = useTripBuilder();

    const [startQuote, { loading }] = useStartQuoteMutation();
    const [hasError, setHasError] = useState(false);
    const { customer } = useAuth();
    const customPromo = Cookies.get("promo");
    const [addCustomPromo] = useAddDraftOrderPromoMutation();
    const draftQuote = useDraftQuoteFragment(draftId);

    useEffect(() => {
        if (customPromo && draftId) {
            const isCustomPromoAlreadyApplied = draftQuote?.order.trips.some(
                (trip) =>
                    trip.openPromoLineItems.some(
                        (promo) => promo.promoCode === customPromo,
                    ),
            );
            // note: this is fire and forget, we let ABE decide on the promo validity
            !isCustomPromoAlreadyApplied &&
                addCustomPromo({
                    variables: {
                        id: draftId,
                        promoCode: customPromo,
                    },
                });
        }
    }, [addCustomPromo, draftId, customPromo, draftQuote?.order.trips]);

    useEffect(() => {
        const shouldInitializeQuote =
            !draftId && departureId && !loading && !hasError;
        if (shouldInitializeQuote) {
            startQuote({
                variables: {
                    input: {
                        departureId,
                        currency: process.env
                            .NEXT_PUBLIC_CURRENCY_CODE as CurrencyCode,
                        gcDepartureId: gcDeparture?._id,
                        promoCode: promoCode || undefined,
                        campaignCode: campaignCode || undefined,
                        ...(!!customer?._id && {
                            customerId: customer._id,
                        }),
                        applyAdvancedRepeatPromo: true,
                    },
                },
                onCompleted: (result) => {
                    if (result.startQuote.__typename === "DraftOrder") {
                        setDraftId(result.startQuote._id);
                    } else {
                        setDepartureId(null);
                        setHasError(true);
                    }
                },
                onError: () => {
                    setDepartureId(null);
                    setHasError(true);
                },
            });
        }
    }, [
        draftId,
        departureId,
        loading,
        promoCode,
        campaignCode,
        gcDeparture,
        hasError,
        startQuote,
        setDraftId,
        setDepartureId,
        customer?._id,
        customPromo,
    ]);
    return { draftId, loading, hasError };
};
